module.exports = __webpack_public_path__ + "img/Chabanov.716736a8.jpeg";